import { render, staticRenderFns } from "./Unlink.vue?vue&type=template&id=bd1c1450"
import script from "./Unlink.vue?vue&type=script&lang=ts"
export * from "./Unlink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports